import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { Stepper } from "@mui/material";
import { Step } from "@mui/material";
import { StepButton } from "@mui/material";
import StepLabel from "@mui/material/StepLabel";
import { styled } from "@mui/material/styles";
import DupontButton from "../DupontButton";
import Check from "@mui/icons-material/Check";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import { useTranslation } from "react-i18next";

import { extractPlantId } from "../../utils/Utils";
import { API_URLS } from "../../network/appUrls";
const Stepper1 = ({
  activeStep,
  setActiveStep,
  handleBack,
  handleNext,
  steps,
  renamingText,
  disableNextButton,
}) => {
  const { t } = useTranslation();

  const basePath = API_URLS.basePath;

  const plantId = extractPlantId();
  const app = useSelector((state) => state.app);
  const QontoConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: "teal",
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: "teal",
      },
    },
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#eaeaf9",
      borderTopWidth: 3,
      borderRadius: 1,
    },
  }));

  const QontoStepIconRoot = styled("div")(({ theme, ownerState }) => ({
    backgroundColor: ownerState.props.completed
      ? "white"
      : ownerState.props.active
        ? "teal"
        : "#ccc",
    borderColor: ownerState.props.completed ? "teal" : "white",
    borderWidth: 1,
    zIndex: 1,
    color: "#fff",
    width: 24,
    height: 24,
    display: "flex",
    borderRadius: "50%",
    borderStyle: ownerState.props.completed ? "solid" : "none",
    justifyContent: "center",
    alignItems: "center",
    "&ownerState.active": {
      backgroundColor: "pink",
    },

    "& .QontoStepIcon-completedIcon": {
      color: "teal",
      zIndex: 1,
      fontSize: 18,
    },
    "& .QontoStepIcon-circle": {
      font: "normal normal normal 12px/12px Diodrum",
      color: "#969696",
      marginTop: 4,
    },
    "& .QontoStepIcon-active": {
      marginTop: 3,
    },
  }));

  const styles = () => ({
    labelContainer: {
      "& $alternativeLabel": {
        marginTop: 0,
      },
    },
    alternativeLabel: {},
    active: {}, //needed so that the &$active tag works
    completed: {},
    disabled: {},
  });

  const handleButtonClick = (item) => {
    setActiveStep(item.index);
  };

  function QontoStepIcon(props) {
    const { active, completed, className, icon } = props;

    return (
      <QontoStepIconRoot ownerState={{ props }} className={className}>
        {completed && <Check className="QontoStepIcon-completedIcon" />}
        {active && <div className="QontoStepIcon-active">{icon} </div>}
        {!active && !completed && (
          <div className="QontoStepIcon-circle">{icon} </div>
        )}
      </QontoStepIconRoot>
    );
  }

  return (
    <div>
      <div style={{ justifyContent: "center", marginBottom: "20px" }}>
        <div
          style={{
            alignItems: "center",
            display: "flex",
            justifyContent: "space-around",

            width: "100%",
          }}
        >
          <div
            style={{
              alignItems: "center",
              display: "flex",
              justifyContent: "space-around",
              marginBottom: 20,
            }}
          >
            <DupontButton
              type="tertiary"
              onClick={handleBack}
              customClass={{ marginRight: "10px" }}
              // disabled={activeStep === 0}
            >
              {activeStep === 0 ? (
                <Link
                  to={`${basePath}Home?plantId=${plantId}`}
                  className="dupont-btn__tertiary--primary "
                >
                  &lt; {t("ValueStrings.back")}
                </Link>
              ) : (
                ` < ${t("ValueStrings.back")}`
              )}
            </DupontButton>
            <DupontButton
              type="tertiary"
              onClick={handleNext}
              disabled={
                app === "ca"
                  ? (activeStep === 2 || activeStep === 4) && disableNextButton
                  : activeStep === 1 && disableNextButton
              }
            >
              {renamingText || t("ValueStrings.next")} &gt;
            </DupontButton>
          </div>
        </div>
        <Stepper
          activeStep={activeStep}
          completed={activeStep === 5 ? "true" : undefined}
          connector={<QontoConnector />}
        >
          {steps(t).map((label, index) => (
            <Step
              key={index}
              sx={{
                "& .MuiStepLabel-root .Mui-completed": {
                  color: "teal",
                },
                "& .MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel":
                  {
                    font: "normal normal normal 16px/20px Diodrum",
                    color: "#000000",
                  },
                "& .MuiStepLabel-root .Mui-active": {
                  color: "teal",
                  font: "normal normal 600 16px/20px Diodrum",
                },
                "& .MuiStepLabel-label.Mui-active.MuiStepLabel-alternativeLabel":
                  {
                    color: "common.white",
                  },
                "& .MuiStepLabel-root .Mui-active .MuiStepIcon-text": {
                  fill: "black",
                },
              }}
            >
              <StepButton onClick={() => handleButtonClick({ index })}>
                <StepLabel StepIconComponent={QontoStepIcon} sx={{ styles }}>
                  {label}
                </StepLabel>
              </StepButton>
            </Step>
          ))}
        </Stepper>
      </div>
    </div>
  );
};
export default Stepper1;
